import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SiteNav.css';

function SiteNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-bar">
          <div className="navbar-spacer" aria-hidden="true" />
          <Link to="/" className="navbar-brand">
            <img src="/logo/profile.jpg" alt="Logo" className="navbar-logo" />
            <h1>Best Audio Books For Free</h1>
          </Link>
          <button
            type="button"
            className="menu-toggle"
            aria-label="Open menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(true)}
          >
            <span className="menu-toggle-bar" />
            <span className="menu-toggle-bar" />
            <span className="menu-toggle-bar" />
          </button>
        </div>
      </nav>

      <div
        className={`side-menu-overlay ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden={!menuOpen}
      />

      <aside className={`side-menu ${menuOpen ? 'open' : ''}`} aria-hidden={!menuOpen}>
        <div className="side-menu-header">
          <h2>Browse</h2>
          <button
            type="button"
            className="side-menu-close"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          >
            ×
          </button>
        </div>
        <nav className="side-menu-links">
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
          <Link to="/books" className={location.pathname === '/books' ? 'active' : ''}>
            All Books
          </Link>
          <Link
            to="/authors"
            className={location.pathname.startsWith('/authors') ? 'active' : ''}
          >
            Authors
          </Link>
          <Link to="/support" className={location.pathname === '/support' ? 'active' : ''}>
            Support
          </Link>
          <Link to="/privacy" className={location.pathname === '/privacy' ? 'active' : ''}>
            Privacy
          </Link>
          <Link
            to="/mansfieldian-app"
            className={location.pathname === '/mansfieldian-app' ? 'active' : ''}
          >
            Mansfieldian App
          </Link>
        </nav>
      </aside>
    </>
  );
}

export default SiteNav;
